/**
 * Maps a marketplace catalog entry to the MarketplaceCard view model (CT-4167).
 */
export const mapMarketplaceCardToUi = (item) => ({
  id: item.id,
  slug: item.slug,
  name: item.name,
  vendor: item.vendor,
  category: item.category,
  description: item.description,
  source: item.source, // 'official' | 'unofficial' | 'partner'
  verified: Boolean(item.verified),
  connectionState: item.connection_state, // 'not_connected' | 'connected' | 'in_marketplace'
  // Only meaningful when connectionState === 'connected' — the live Status
  // System state (CT-4195), so an already-connected marketplace card shows
  // "Schema drift"/"Active"/etc. instead of a static "Connected" label.
  status: item.status ?? null,
  activeCapabilities: (item.capabilities ?? [])
    .filter((capability) => capability.active)
    .map((capability) => capability.type),
  instancesCount: item.instances_count ?? null,
  callsPerDay: item.calls_per_day ?? null,
  // Editorial fields consumed only by the Featured Card (CT-4163).
  headline: item.featured_headline ?? null,
  featuredDescription: item.featured_description ?? null,
});
